<template>
  <div class="container">
    <div class="header">
      <span class="preview_font">预览</span>
      <span class="close_icon" @click="close">×</span>
    </div>
    <template v-if="pdfFlag">
      <div ref="pbfBox" class="pdf_canvas" style="height:100%; margin:0 auto; width: 70%">
        <template v-for="item in pdfCount">
          <canvas :key="'canvas_'+item" :id="'pdf_'+item" oncontextmenu="return false">浏览器不支持预览</canvas>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
  data () {
    return {
      pdfObject: {numPages: 0},
      currPage: 1,
      loadPage: 0,
      scale: 2,
      handoutUrl: '',
      showFlag: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    pdfCount: function(){
      return this.pdfObject.numPages
    },
    pdfFlag: function(){
      return this.url.toLowerCase().includes('.pdf')
    },
  },
  created: function(){
    this.initPdfUrl()
  },
  methods: {
    initPdfUrl: function(){
      this.initPdf(this.url)
    },
    initPdf (url) {
      if (!url) { 
        return false 
      }
      this.handoutUrl = url.includes('http') ? url : this.$server.qxyRes + url
      PDFJS.getDocument(
        {
          url:this.handoutUrl,
          cMapUrl: `https://cdn.jsdelivr.net/npm/pdfjs-dist@2.2.228/cmaps/`,
          cMapPacked: true
        }
      ).then((pdf) => {
        if (pdf) {
          this.pdfObject = pdf
          setTimeout(() => {
            var currCanvas = document.getElementById('pdf_1')
            this.renderPage(currCanvas)
          }, 200)
        }
      })
    },
    renderPage (pdfCanvas) {
      this.loadPage++
      this.pdfObject.getPage(this.loadPage).then((page) => {
        var viewport = page.getViewport(this.scale)
        pdfCanvas.height = viewport.height
        pdfCanvas.width = viewport.width
        var renderContext = {
          canvasContext: pdfCanvas.getContext('2d'),
          viewport: viewport
        }
        var renderTask = page.render(renderContext)
        renderTask.promise.then(() => {
          let nextNum = this.loadPage + 1
          if (nextNum <= this.pdfCount) {
            let currCanvas = document.getElementById('pdf_' + nextNum)
            this.renderPage(currCanvas)
          }
        })
      })
    },
    close:function() {
      this.$emit('close',false)
    }
  }
}
</script>
<style scoped>
::-webkit-scrollbar{
  display: none;
}
.container{
  background: white;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header{
  display: flex;
  width: 100%;
  background: #1E88E5;
  height: 100px;
  color: white;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
}
.header .preview_font{
  font-size: 34px;
  margin-left: 50px;
}
.header .close_icon{
  font-size: 50px;
  margin-right: 50px;
}
.pdf_canvas{
  padding-top: 100px;
  overflow: auto;
  -webkit-overflow-scrolling: touch !important;
  display: flex;
  flex-direction: column;
}
canvas{
  min-width: 70%;
  max-width: 100%;
}
</style>
